module.exports = __webpack_public_path__ + "static/img/ic_presentation.18033f70.svg";